<template>
    <div>
             <!-- v-if="all_ready" -->
        <div class="row">
            <div class="col-12">
                <section class="card card-dashboard">
                    <div class="card-body pt-2 pb-0">
                        <div class="row border-bottom mb-2 no-gutters">
                            <small class="col-12 text-muted text-center">Filtrar datos históricos</small>
                        </div>
                        <div class="row">
                            <div class="col-6 col-md-3 form-group">
                                <label class="control-label">Establecimiento</label>
                                <el-select v-model="form.establishment_id" @change="loadAll">
                                    <el-option
                                    v-for="option in establishments"
                                    :key="option.id"
                                    :value="option.id"
                                    :label="option.name"
                                    ></el-option>
                                </el-select>
                            </div>
                            <div class="col-6 col-md-3">
                                <label class="control-label">Periodo</label>
                                <el-select v-model="form.period" @change="changePeriod">
                                    <el-option key="all" value="all" label="Todos"></el-option>
                                    <el-option key="last_week" value="last_week" label="Última semana"></el-option>
                                    <el-option key="month" value="month" label="Por mes"></el-option>
                                    <el-option key="between_months" value="between_months" label="Entre meses"></el-option>
                                    <el-option key="date" value="date" label="Por fecha"></el-option>
                                    <el-option key="between_dates" value="between_dates" label="Entre fechas"></el-option>
                                </el-select>
                            </div>
                            <template v-if="form.period === 'month' || form.period === 'between_months'">
                                <div class="col-6 col-md-3">
                                    <label class="control-label">Mes de</label>
                                    <el-date-picker
                                        v-model="form.month_start"
                                        type="month"
                                        @change="changeDisabledMonths"
                                        value-format="yyyy-MM"
                                        format="MM/yyyy"
                                        :clearable="false"
                                    ></el-date-picker>
                                </div>
                            </template>
                            <template v-if="form.period === 'between_months'">
                                <div class="col-6 col-md-3">
                                    <label class="control-label">Mes al</label>
                                    <el-date-picker
                                        v-model="form.month_end"
                                        type="month"
                                        :picker-options="pickerOptionsMonths"
                                        @change="loadAll"
                                        value-format="yyyy-MM"
                                        format="MM/yyyy"
                                        :clearable="false"
                                    ></el-date-picker>
                                </div>
                            </template>
                            <template v-if="form.period === 'date' || form.period === 'between_dates'">
                                <div class="col-6 col-md-3">
                                    <label class="control-label">Fecha del</label>
                                    <el-date-picker
                                        v-model="form.date_start"
                                        type="date"
                                        @change="changeDisabledDates"
                                        value-format="yyyy-MM-dd"
                                        format="dd/MM/yyyy"
                                        :clearable="false"
                                    ></el-date-picker>
                                </div>
                            </template>
                            <template v-if="form.period === 'between_dates'">
                                <div class="col-6 col-md-3">
                                    <label class="control-label">Fecha al</label>
                                    <el-date-picker
                                        v-model="form.date_end"
                                        type="date"
                                        :picker-options="pickerOptionsDates"
                                        @change="loadAll"
                                        value-format="yyyy-MM-dd"
                                        format="dd/MM/yyyy"
                                        :clearable="false"
                                    ></el-date-picker>
                                </div>
                            </template>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    
        <div class="row">
            <div class="col-xl-12">
                <div class="row">
                    <template v-if="configuration.dashboard_sales">
                        <div class="col-xl-3">
                            <section class="card card-dashboard">
                                <div class="card-body" v-if="loaders.sale_note">
                                    <template >
                                        <loader-graph :rows="4" :columns="1" :radius="50"></loader-graph>
                                    </template>
                                </div>
                                <div class="card-body" v-show="!loaders.sale_note">
                                    <div class="widget-summary">
                                        <div class="widget-summary-col" v-if="sale_note">
                                            <div class="row no-gutters">
                                                <div class="col-md-12 m-b-10">
                                                    <label>Notas de venta</label>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <x-graph type="doughnut" :all-data="sale_note.graph"></x-graph>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body p-0" v-show="!loaders.sale_note">
                                    <table class="table mb-0 table-sm">
                                        <tbody>
                                            <tr class="text-info text-bold">
                                                <td>Total Cobrado</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{ sale_note.totals.total_payment }}</td>
                                            </tr>
                                            <tr class="text-danger text-bold">
                                                <td>Pendiente de cobro</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{ sale_note.totals.total_to_pay }}</td>
                                            </tr>
                                            <tr class="text-bold">
                                                <td class="">Total</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{ sale_note.totals.total }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                        </div>
    
                        <div class="col-xl-3" v-if="soapCompany != '03'">
                            <section class="card card-dashboard">
                                <div class="card-body" v-if="loaders.document">
                                    <template >
                                        <loader-graph :rows="4" :columns="1" :radius="50"></loader-graph>
                                    </template>
                                </div>
                                <div class="card-body" v-show="!loaders.document">
                                    <div class="widget-summary">
                                        <div class="widget-summary-col" v-if="document">
                                            <div class="row no-gutters">
                                                <div class="col-md-12 m-b-10">
                                                    <label>Comprobantes</label>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <x-graph type="doughnut" :all-data="document.graph"></x-graph>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body p-0" v-show="!loaders.document">
                                    <table class="table mb-0 table-sm">
                                        <tbody>
                                            <tr class="text-info text-bold">
                                                <td>Total Cobrado</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{ document.totals.total_payment }}</td>
                                            </tr>
                                            <tr class="text-danger text-bold">
                                                <td>Pendiente de cobro</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{ document.totals.total_to_pay }}</td>
                                            </tr>
                                            <tr class="text-bold">
                                                <td class="">Total</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{ document.totals.total }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                        </div>
    
                        <div class="col-xl-6 col-md-6">
                            <section class="card card-dashboard">
                                <div class="card-body" v-if="loaders.general">
                                    <template >
                                        <loader-graph :rows="2" :columns="3" :radius="100"></loader-graph>
                                    </template>
                                </div>
                                <div class="card-body" v-show="!loaders.general">
                                    <div class="widget-summary">
                                        <div class="widget-summary-col" v-if="general">
                                            <div class="summary">
                                                <div class="row no-gutters">
                                                    <div class="col-md-12 m-b-10">
                                                        <label>Totales: Monto S/.</label>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <x-graph-line :all-data="general.graph"></x-graph-line>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body p-0" v-show="!loaders.general">
                                    <table class="table mb-0 table-sm">
                                        <tbody>
                                            <tr>
                                                <td width="60%"></td>
                                                <td width="20%" class="text-center">Porcentaje</td>
                                                <td width="20%" class="text-right">Monto S/.</td>
                                            </tr>
                                            <tr class="text-info text-bold">
                                                <td width="60%">Total notas de venta</td>
                                                <td width="20%" class="text-center">{{ general.totals.percentage_total_sale_notes }}%</td>
                                                <td width="20%" class="text-right font-weight-bold">S/&nbsp;{{ general.totals.total_sale_notes }}</td>
                                            </tr>
                                            <tr class="text-danger text-bold">
                                                <td width="60%">
                                                    Total comprobantes
                                                    <el-tooltip class="item" effect="dark"
                                                        content="Factura + Boleta - Nota de Crédito + Nota de Débito"
                                                        placement="top"
                                                    >
                                                        <i class="fa fa-info-circle"></i>
                                                    </el-tooltip>
                                                </td>
                                                <td width="20%" class="text-center">{{ general.totals.percentage_total_documents }}%</td>
                                                <td width="20%" class="text-right font-weight-bold">
                                                    S/&nbsp;{{ general.totals.total_documents }}
                                                    <el-tooltip class="item" effect="dark"
                                                        placement="top"
                                                    >
                                                        <div slot="content">
                                                            <span v-html="general.totals.text_help_documents"></span>
                                                        </div>
                                                        <i class="fa fa-info-circle"></i>
                                                    </el-tooltip>
                                                </td>
                                            </tr>
                                            <tr class="text-bold">
                                                <td width="60%">Total</td>
                                                <td width="20%" class="text-center">{{ general.totals.percentage_total }}%</td>
                                                <td width="20%" class="text-right font-weight-bold">S/&nbsp;{{ general.totals.total }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                        </div>

                        <div class="col-xl-6 col-md-6">
                            <section class="card card-dashboard">
                                <div class="card-body" v-if="loaders.general">
                                    <template >
                                        <loader-graph :rows="2" :columns="3" :radius="100"></loader-graph>
                                    </template>
                                </div>
                                <div class="card-body" v-show="!loaders.general">
                                    <div class="widget-summary">
                                        <div class="widget-summary-col" v-if="general">
                                            <div class="summary">
                                                <div class="row no-gutters">
                                                    <div class="col-md-12 m-b-10">
                                                        <label>Totales: Cantidad</label>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <x-graph-line :all-data="general_qty.graph"></x-graph-line>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body p-0" v-show="!loaders.general_qty">
                                    <table class="table mb-0 table-sm">
                                        <tbody>
                                            <tr>
                                                <td width="60%"></td>
                                                <td width="20%" class="text-center">Porcentaje</td>
                                                <td width="20%" class="text-right">Cantidad</td>
                                            </tr>
                                            <tr class="text-info text-bold">
                                                <td width="60%">Total notas de venta</td>
                                                <td width="20%" class="text-center">{{ general_qty.totals.percentage_qty_sale_notes }}%</td>
                                                <td width="20%" class="text-right font-weight-bold">{{ general_qty.totals.qty_sale_notes }}</td>
                                            </tr>
                                            <tr class="text-danger text-bold">
                                                <td width="60%">
                                                    Total comprobantes
                                                    <el-tooltip class="item" effect="dark"
                                                        content="Factura + Boleta + Nota de Crédito + Nota de Débito"
                                                        placement="top"
                                                    >
                                                        <i class="fa fa-info-circle"></i>
                                                    </el-tooltip>
                                                </td>
                                                <td width="20%" class="text-center">
                                                    {{ general_qty.totals.percentage_qty_documents }}%
                                                    <el-tooltip class="item" effect="dark"
                                                        placement="top"
                                                    >
                                                        <div slot="content">
                                                            <span v-html="general_qty.totals.text_help_percentage_qty"></span>
                                                        </div>
                                                        <i class="fa fa-info-circle"></i>
                                                    </el-tooltip>
                                                </td>
                                                <td width="20%" class="text-right font-weight-bold">
                                                    {{ general_qty.totals.qty_documents }}
                                                    <el-tooltip class="item" effect="dark"
                                                        placement="top"
                                                    >
                                                        <div slot="content">
                                                            <span v-html="general_qty.totals.text_help_qty"></span>
                                                        </div>
                                                        <i class="fa fa-info-circle"></i>
                                                    </el-tooltip>
                                                </td>
                                            </tr>
                                            <tr class="text-bold">
                                                <td width="60%">Total</td>
                                                <td width="20%" class="text-center">{{ general_qty.totals.percentage_qty_total }}%</td>
                                                <td width="20%" class="text-right font-weight-bold">
                                                    {{ general_qty.totals.qty_total }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                        </div>
                    </template>
    
                    <template v-if="configuration.dashboard_general">
                        <div class="col-xl-3 col-md-3">
                            <section class="card card-dashboard">
                                <div class="card-body" v-if="loaders.balance">
                                    <template>
                                        <loader-graph :rows="4" :columns="1" :radius="50"></loader-graph>
                                    </template>
                                </div>
                                <div class="card-body" v-show="!loaders.balance">
                                    <div class="widget-summary">
                                        <div class="widget-summary-col" v-if="document">
                                            <div class="row no-gutters">
                                                <div class="col-md-12 m-b-10">
                                                    <label>
                                                        Balance
                                                        <el-tooltip
                                                            class="item"
                                                            effect="dark"
                                                            content="Ventas - Compras - Gastos"
                                                            placement="top-start"
                                                            >
                                                                <i class="fa fa-info-circle"></i>
                                                            </el-tooltip>
                                                        </label>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <x-graph type="doughnut" :all-data="balance.graph"></x-graph>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body p-0" v-show="!loaders.balance">
                                    <table class="table mb-0 table-sm">
                                        <tbody>
                                            <tr class="text-info text-bold">
                                                <td>
                                                    <el-popover placement="right" width="100%" trigger="hover">
                                                        <p><span class="custom-badge">T. Ventas - T. Compras/Gastos</span></p>
                                                        <p>Total comprobantes:<span class="custom-badge pull-right">S/ {{ balance.totals.total_document }}</span></p>
                                                        <p>Total notas de venta:<span class="custom-badge pull-right">S/ {{ balance.totals.total_sale_note }}</span></p>
                                                        <p>Total compras:<span class="custom-badge pull-right">- S/ {{ balance.totals.total_purchase }}</span></p>
                                                        <p>Total gastos:<span class="custom-badge pull-right">- S/ {{ balance.totals.total_expense }}</span></p>
                                                        <el-button icon="el-icon-view" type="primary" size="mini" slot="reference" circle></el-button>
                                                    </el-popover>
                                                    Totales
                                                </td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{ balance.totals.all_totals_payment }}</td>
                                            </tr>
                                            <tr class="text-danger text-bold">
                                                <td>
                                                    <el-popover placement="right" width="100%" trigger="hover">
                                                    <p><span class="custom-badge">T. Pagos Ventas - T. Pagos Compras/Gastos</span></p>
                                                    <p>Total pagos comprobantes:<span class="custom-badge pull-right">S/ {{ balance.totals.total_payment_document }}</span></p>
                                                    <p>Total pagos notas de venta:<span class="custom-badge pull-right">S/ {{ balance.totals.total_payment_sale_note }}</span></p>
                                                    <p>Total pagos compras:<span class="custom-badge pull-right">- S/ {{ balance.totals.total_payment_purchase }}</span></p>
                                                    <p>Total pagos gastos:<span class="custom-badge pull-right">- S/ {{ balance.totals.total_payment_expense }}</span></p>
                                                    <el-button icon="el-icon-view" type="danger" size="mini" slot="reference" circle></el-button>
                                                    </el-popover>
                                                    Total pagos
                                                </td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{ balance.totals.all_totals_payment }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                        </div>
    
                        <div class="col-xl-3 col-md-3">
                            <section class="card card-dashboard">
                                <div class="card-body" v-if="loaders.utility">
                                    <template>
                                        <loader-graph :rows="4" :columns="1" :radius="50"></loader-graph>
                                    </template>
                                </div>
                                <div class="card-body" v-show="!loaders.utility">
                                    <div class="widget-summary">
                                        <div class="widget-summary-col" v-if="utilities">
                                            <div class="row no-gutters">
                                                <div class="col-md-12 m-b-10">
                                                    <label>Utilidades/Ganancias</label>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <x-graph type="doughnut" :all-data="utilities.graph"></x-graph>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body p-0" v-show="!loaders.utility">
                                    <table class="table mb-0 table-sm">
                                        <tbody>
                                            <tr>
                                                <td colspan="2">
                                                    <el-checkbox  v-model="form.enabled_expense" @change="loadDataUtilities">Considerar gastos</el-checkbox><br>
                                                    <el-checkbox  v-model="filter_item" @change="changeFilterItem">Filtrar por producto</el-checkbox>
                                                </td>
                                            </tr>
                                            <tr v-if="filter_item">
                                                <td colspan="2">
                                                    <div class="form-group">
                                                        <el-select v-model="form.item_id" filterable remote  popper-class="el-select-customers"  clearable
                                                            placeholder="Buscar producto"
                                                            :remote-method="searchRemoteItems"
                                                            :loading="loading_search"
                                                            @change="loadDataUtilities">
                                                            <el-option v-for="option in items" :key="option.id" :value="option.id" :label="option.description"></el-option>
                                                        </el-select>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr class="text-info text-bold">
                                                <td>Ingreso</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{ utilities.totals.total_income }}</td>
                                            </tr>
                                            <tr class="text-danger text-bold">
                                                <td>Egreso</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{ utilities.totals.total_egress }}</td>
                                            </tr>
                                            <tr class="text-bold">
                                                <td class="">Utilidad</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{ utilities.totals.utility }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                        </div>
    
                        <div class="col-xl-6 col-md-6">
                            <section class="card card-dashboard">
                                <div class="card-body" v-if="loaders.purchase">
                                    <template>
                                        <loader-graph :rows="2" :columns="3" :radius="100"></loader-graph>
                                    </template>
                                </div>
                                <div class="card-body" v-show="!loaders.purchase">
                                    <div class="widget-summary">
                                        <div class="widget-summary-col" v-if="general">
                                            <div class="summary">
                                                <div class="row no-gutters">
                                                    <div class="col-md-12 m-b-10">
                                                        <label>Compras
                                                            <el-tooltip
                                                            class="item"
                                                            effect="dark"
                                                            content="Aplica filtro por establecimiento"
                                                            placement="top-start"
                                                            >
                                                                <i class="fa fa-info-circle"></i>
                                                            </el-tooltip>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="row m-t-20">
                                                    <div class="col-md-12">
                                                        <x-graph-line :all-data="purchase.graph"></x-graph-line>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body p-0" v-show="!loaders.purchase">
                                    <table class="table mb-0 table-sm">
                                        <tbody>
                                            <tr class="text-info text-bold">
                                                <td>Total percepciones</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{ purchase.totals.purchases_total_perception }}</td>
                                            </tr>
                                            <tr class="text-danger text-bold">
                                                <td>Total compras</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{ purchase.totals.purchases_total }}</td>
                                            </tr>
                                            <tr class="text-bold">
                                                <td class="">Total</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{ purchase.totals.total }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <!-- <div v-else>
        <div class="text-center">Cargando...</div>
    </div> -->
</template>

<script>
    import LoaderGraph from "./loaders/l-graph.vue"

    export default {
        name: "DashboardStatistics",
        props: ['soapCompany', 'configuration'],
        components : { LoaderGraph },
        data() {
            return {
                resource: "dashboard",
                form: {},
                loaders: {},
                establishments: [],
                balance: {
                    totals: {},
                    graph: {},
                },
                document: {
                    totals: {},
                    graph: {},
                },
                sale_note: {
                    totals: {},
                    graph: {},
                },
                general: {
                    totals: {},
                    graph: {},
                },
                general_qty: {
                    totals: {},
                    graph: {},
                },
                purchase: {
                    totals: {},
                    graph: {},
                },
                utilities: {
                    totals: {},
                    graph: {},
                },
                pickerOptionsMonths: {
                    disabledDate: (time) => {
                    time = moment(time).format("YYYY-MM");
                    return this.form.month_start > time;
                    },
                },
                pickerOptionsDates: {
                    disabledDate: (time) => {
                    time = moment(time).format("YYYY-MM-DD");
                    return this.form.date_start > time;
                    },
                },
                filter_item: false,
                loading_search: false,
                all_items: [],
                items: [],
                all_ready: false
            }
        },
        created() {
            this.initForm()
            this.initLoaders()
        },
        async mounted() {
            await this.fetchFilters()
            this.all_ready = true
            this.loadAll()

            this._onResizeCharts = () => {
                this.$nextTick(() => {
                // si usas echarts:
                // this.chart?.resize()

                // si tus componentes de gráfico escuchan window.resize, con esto basta:
                window.dispatchEvent(new Event('resize'))
                })
            }
            this.$eventHub.$on('dashboard:resize-charts', this._onResizeCharts)
        },

        methods: {
            async fetchFilters() {
                await this.$http.get(`/${this.resource}/filter`).then((response) => {
                    this.establishments = response.data.establishments;
                    this.form.establishment_id = this.establishments.length > 0 ?
                                                    this.establishments[0].id : null;
                })
            },
            initForm() {
                this.form = {
                    item_id: null,
                    establishment_id: null,
                    enabled_expense: null,
                    enabled_move_item: false,
                    enabled_transaction_customer: false,
                    period: "last_week",
                    date_start: moment().subtract(7, 'days').format("YYYY-MM-DD"),
                    date_end: moment().format("YYYY-MM-DD"),
                    month_start: moment().format("YYYY-MM"),
                    month_end: moment().format("YYYY-MM"),
                    customer_id: null,
                }
            },
            loadAll() {
                this.loadData();
                this.loadDataAditional();
                this.loadDataUtilities();
                this.changeStock();
            },
            loadData() {
                this.showLoadersLoadData();

                this.$http.post(`/${this.resource}/data`, this.form).then((response) => {
                    this.document = response.data.data.document;
                    // this.documents_quantity = response.data.data.quantity;
                    this.balance = response.data.data.balance;
                    this.sale_note = response.data.data.sale_note;
                    this.general = response.data.data.general;
                    this.general_qty = response.data.data.general_qty
                    this.customers = response.data.data.customers;
                    this.items = response.data.data.items;
                    this.hideLoadersLoadData();
                });
            },
            showLoadersLoadData() {
                this.loaders.document = true;
                this.loaders.sale_note = true;
                this.loaders.general = true;
                this.loaders.balance = true;
                this.loaders.general_qty = true
            },
            hideLoadersLoadData() {
                this.loaders.document = false;
                this.loaders.sale_note = false;
                this.loaders.general = false;
                this.loaders.balance = false;
                this.loaders.general_qty = false
            },
            initLoaders() {
                this.loaders = {
                    document: true,
                    sale_note: true,
                    general: true,
                    balance: true,
                    utility: true,
                    purchase: true,
                    items_by_sales: true,
                    top_customers: true,
                    general_qty: true
                };
            },
            loadDataAditional() {
                this.showLoadersLoadDataAditional();

                this.$http
                    .post(`/${this.resource}/data_aditional`, this.form)
                    .then((response) => {
                    this.purchase = response.data.data.purchase;
                    this.items_by_sales = response.data.data.items_by_sales;
                    this.top_customers = response.data.data.top_customers;
                    this.hideLoadersLoadDataAditional();
                    });
            },
            showLoadersLoadDataAditional() {
                this.loaders.purchase = true;
                this.loaders.items_by_sales = true;
                this.loaders.top_customers = true;
            },
            hideLoadersLoadDataAditional() {
                this.loaders.purchase = false;
                this.loaders.items_by_sales = false;
                this.loaders.top_customers = false;
            },
            loadDataUtilities() {
                const form = { ...this.form }

                // Mantiene sincronizados los filtros que reciben el padre
                // y ReportsStrategics.
                this.$emit("changeUtilities", form)

                this.loaders.utility = true

                return this.$http
                    .post(`/${this.resource}/utilities`, form)
                    .then((response) => {
                        const utilities = response.data.data.utilities

                        // Actualiza el gráfico y la tabla de Statistics.
                        this.utilities = utilities

                        // Entrega exactamente el mismo resultado a Totals.
                        this.$emit("utilitiesLoaded", utilities)

                        this.loaders.utility = false
                    })
            },
            changeStock() {
                // FIXME: ver que se ejecute bien
                this.$eventHub.$emit("changeStock", this.form.establishment_id);
            },
            changePeriod() {
                if (this.form.period === "month") {
                    this.form.month_start = moment().format("YYYY-MM");
                    this.form.month_end = moment().format("YYYY-MM");
                }
                if (this.form.period === "between_months") {
                    this.form.month_start = moment().startOf("year").format("YYYY-MM"); //'2019-01';
                    this.form.month_end = moment().endOf("year").format("YYYY-MM");
                }
                if (this.form.period === "date") {
                    this.form.date_start = moment().format("YYYY-MM-DD");
                    this.form.date_end = moment().format("YYYY-MM-DD");
                }
                if (this.form.period === "between_dates") {
                    this.form.date_start = moment().startOf("month").format("YYYY-MM-DD");
                    this.form.date_end = moment().endOf("month").format("YYYY-MM-DD");
                }
                this.loadAll()
            },
            changeDisabledMonths() {
                if (this.form.month_end < this.form.month_start) {
                    this.form.month_end = this.form.month_start;
                }
                this.loadAll();
            },
            changeDisabledDates() {
                if (this.form.date_end < this.form.date_start) {
                    this.form.date_end = this.form.date_start;
                }
                this.loadAll();
            },
            changeFilterItem() {
                this.form.item_id = null;
                this.loadDataUtilities();
            },
            searchRemoteItems(input) {
                if (input.length > 1) {
                    this.loading_search = true;
                    let parameters = `input=${input}`;
                    this.$http
                    .get(`/reports/data-table/items/?${parameters}`)
                    .then((response) => {
                        this.items = response.data.items;
                        this.loading_search = false;

                        if (this.items.length == 0) {
                        this.filterItems();
                        }
                    });
                } else {
                    this.filterItems();
                }
            },
            filterItems() {
                this.items = this.all_items;
            },
        },
    }
</script>


// WEBPACK FOOTER //
// modules/Dashboard/Resources/assets/js/components/Statistics.vue